import React, { useEffect, useRef, useState } from 'react';
//import { useRouter } from 'next/router';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import {useNavigate} from "react-router-dom";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { Toast } from 'primereact/toast';
import { useDeleteKpiTaskMutation } from 'apis/kpiApi';
import { useDeletePriorityTaskMutation } from 'apis/priorityApi';
import { useDeleteSAMTaskMutation } from 'apis/samApi';

export default function TaskMenu(props) {
    const menu = useRef(null);
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const toast = useRef(null);
    const [deleteKpiTask] = useDeleteKpiTaskMutation();
    const [deletePriorityTask] = useDeletePriorityTaskMutation();
    const [deleteSamTask] = useDeleteSAMTaskMutation();

    const acceptDelete = (deletable) => {
        
        if(deletable?.type === "KPI") {
            deleteKpiTask(deletable.id);
        } else if(deletable?.type === "Priority") {
            deletePriorityTask(deletable.id);
        } else if(deletable?.type === "SAM") {
            deleteSamTask(deletable.id);
        }
    };

   
    const confirmDelete = (event, deletable) => {
        confirmPopup({
            target: event?.currentTarget || event?.getTarget(),
            message: 'Are you sure you want to delete the task and all sub-tasks beneath?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => acceptDelete(deletable)
        });
    };

    useEffect(() => {
        const items = [];
        if(props?.editTaskEndpoint) {
            items.push(
                {
                    label: 'Edit',
                    icon: 'pi pi-pencil',
                    command: () => {
                        if(props?.editTaskEndpoint) {
                            navigate(props.editTaskEndpoint);
                        }
                    }
                }
            );
        }

        if(props?.newSubTaskEndpoint) {
            items.push(
                {
                    label: 'Add Subtask',
                    icon: 'pi pi-plus',
                    command: () => {
                        if(props?.newSubTaskEndpoint) {
                            navigate(props.newSubTaskEndpoint);
                        }
                    }
                }
            );
        }

        if(props?.deleteTask) {
            items.push(
                {
                    label: 'Delete',
                    icon: 'pi pi-trash',
                    command: () => {
                        if(props?.deleteTask) {
                            confirmDelete(menu.current, props.deleteTask);
                        }
                    }
                }
            );
        }
        setItems(items);
    }, [props?.editTaskEndpoint, props?.newSubTaskEndpoint]);

    
    const optionsClicked = (e) => {
        e.preventDefault(); 
        menu.current.toggle(e);
    }
   
    return (
        <div className="card flex justify-content-center">
            <Toast ref={toast} />
            <ConfirmPopup />
            {items && items.length > 1 &&
                <>
                    <Menu model={items} popup ref={menu} />
                    <Button label="" icon="pi pi-cog" onClick={optionsClicked} /> 
                </>
            }
            {items && items.length === 1 && props?.editTaskEndpoint &&
                <Button label="" icon="pi pi-pencil" onClick={(e) => {e.preventDefault(); navigate(props.editTaskEndpoint)}} /> 
            }
            {items && items.length === 1 && props?.newSubTaskEndpoint &&
                <Button label="" icon="pi pi-plus" onClick={(e) => {e.preventDefault(); navigate(props.newSubTaskEndpoint)}} /> 
            }

            {items && items.length === 1 && props?.deleteTask &&
                <Button label="" icon="pi pi-trash" onClick={(e) => {e.preventDefault(); confirmDelete(e, props.deleteTask)}} /> 
            }
        </div>
    )
}
